var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7476 18.0849C17.0381 19.3879 14.9567 20.1098 12.8076 20.1449C5.80756 20.1449 1.80756 12.1449 1.80756 12.1449C3.05145 9.82679 4.77669 7.8015 6.86756 6.20489M10.7076 4.38489C11.3959 4.22377 12.1006 4.14323 12.8076 4.14489C19.8076 4.14489 23.8076 12.1449 23.8076 12.1449C23.2005 13.2805 22.4766 14.3496 21.6476 15.3349M14.9276 14.2649C14.6529 14.5596 14.3217 14.796 13.9537 14.96C13.5857 15.124 13.1885 15.2122 12.7856 15.2193C12.3828 15.2264 11.9827 15.1523 11.6092 15.0014C11.2356 14.8505 10.8963 14.6259 10.6114 14.341C10.3265 14.0562 10.1019 13.7168 9.95107 13.3433C9.80018 12.9697 9.72608 12.5696 9.73319 12.1668C9.7403 11.764 9.82846 11.3667 9.99243 10.9987C10.1564 10.6307 10.3928 10.2995 10.6876 10.0249",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.80756 1.1449L23.8076 23.1449",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.807556 0.144897)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.ce2dc4626ff454663a728ed412fe25fc.svg";
export { ForwardRef as ReactComponent };